// Forhåndslasting av sidekoden når musen holdes over (eller fokus lander på)
// en lenke i menyen. Sidene er delt opp med React.lazy, så første besøk på en
// side måtte ellers vente på nedlasting etter klikket. Importene peker på de
// samme modulene som de lazy-lastede rutene, så Vite gjenbruker chunkene.

const prefetchers: Record<string, () => Promise<unknown>> = {
  "/work_items": () => import("../workItems/WorkItemList"),
  "/companies": () => import("../companies/CompanyList"),
  "/contacts": () => import("../contacts/ContactList"),
  "/projects": () => import("../projects/ProjectList"),
  "/prospects": () => import("../prospects/ProspectsPage"),
  "/deals": () => import("../deals/DealList"),
  "/products": () => import("../products/ProductList"),
  "/reports": () => import("../reports/ReportsPage"),
  "/email": () => import("../email/EmailComposePage"),
};

const started = new Set<string>();

export const prefetchRoute = (path: string) => {
  if (started.has(path)) return;
  const prefetch = prefetchers[path];
  if (!prefetch) return;
  started.add(path);
  // Feiler nedlastingen (f.eks. uten nett), prøver vi igjen neste gang.
  prefetch().catch(() => started.delete(path));
};
